import { takeLatest } from 'redux-saga/effects';
import { FETCH_ORGANIZATION_LIST_REQUEST } from '../../redux/modules/organization/organization-actions';
import fetchOrganizationListWorkerSaga from './organizationWorkerSaga';

export default function* fetchOrganizationListSaga() {
    yield takeLatest(FETCH_ORGANIZATION_LIST_REQUEST, fetchOrganizationListWorkerSaga);
}
